<template>
  <!-- <testate @apriDettaglio="apriDettaglio"/> -->
  <testate />
</template>

<script>
  import { verificaLicenza } from '@/mixins/verificaLicenza.js'
  import Testate from './components/testate'

  export default {
    components: {
      Testate
    },
    mixins: [verificaLicenza],
    data: () => ({
      step: 1,
      chiaveDocumento: null
    }),
    async mounted() {
      await this.gestioneToken()
      // this.$store.commit('lotti/SET_PAGE', 'testata')
    },
    computed: {
/*       gotoBase() {
        return this.$store.getters['lotti/gotoBase']
      } */
    },
    watch: {
/*       gotoBase(value) {
        if (value) {
          this.step = 1
          this.$store.commit('lotti/CLEAR_GOTO_BASE')
        }
      } */
    },
    methods: {
/*       apriDettaglio(chiave) {
        this.chiaveDocumento = chiave
        this.$store.commit('lotti/SET_PAGE', 'dettaglio')
        this.step = 2
      },
      tornaIndietro() {
        this.step = 1
        this.$store.commit('lotti/SET_PAGE', 'testata')
        this.$store.commit('lotti/SET_CHIAVE', null)
        this.$store.commit('lotti/CLEAR_DOCUMENTO')
        this.chiaveDocumento = null
      } */
    }
  }
</script>
